var angular = require('angular');
var _module = require('./index');

_module.directive('marketingMaterials', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/marketing-materials.tmpl.html',
        scope: {
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;

            }
        ]
    };
}]);
